import { Analysis } from 'common-spectrum';
import { hgParseMicromeritics } from 'physical-chemistry-parser';

export function fromMicromeritics(blob) {
  let analysis = new Analysis();
  const parsed = hgParseMicromeritics(blob);

  let meta = {
    ...parsed.meta.header,
    ...parsed.meta.summaryReport,
  };

  analysis.pushSpectrum(
    {
      x: {
        data: parsed.variables.C.data,
        label: parsed.variables.C.label,
        units: parsed.variables.C.units,
        type: 'INDEPENDENT',
      },
      y: {
        data: parsed.variables.B.data,
        label: parsed.variables.B.label,
        units: parsed.variables.B.units,
        type: 'DEPENDENT',
      },
    },
    {
      dataType: 'Hg porosimetry',
      title: meta.Sample,
      meta,
    },
  );

  return analysis;
}
